require ("./toggle.scss");
const PropTypes = require('prop-types');
// @ commons
import { recordLink, EVENT_TOGGLE_ON, EVENT_TOGGLE_OFF } from 'utilities/tagging';
// @ vendor
const React = require('react');
const classNames = require('classnames');

// @ constants
const { OPENBANK_PRODUCT_BANKING, OPENBANK_PRODUCT_WEALTH } = require('constants/index');

class Toggle extends React.Component {
    constructor(props) {
        super(props);
    }

    handleClick = (evt) => {
        const checkbox = this.checkboxChecked;
        evt.stopPropagation();
        if (evt.target !== checkbox && this.props.checked) {
            evt.preventDefault();
            checkbox.focus();

            this.props.onClick(!checkbox.checked);
            this.tagToggle(EVENT_TOGGLE_OFF)
        } else {
            this.props.onClick(checkbox.checked);
            this.tagToggle(EVENT_TOGGLE_ON)
        }
    }

    tagToggle = (eventName) => {
        const {
            eventCategory,
            eventTag
        } = this.props
        eventCategory && eventTag && recordLink(eventCategory, eventName || this.props.eventName, eventTag)
    }

    render(){
        const { checked, defaultChecked, product } = this.props;
        const isChecked = checked || defaultChecked;
        const classes = classNames('toggle', {
          'toggle--checked': isChecked
        });
        const trackClasses = classNames('toggle-track', {
            'toggle-track--checked': isChecked,
            'toggle-track--wealth': product === OPENBANK_PRODUCT_WEALTH
        });

        return (
            <div className={classes} onClick={this.handleClick}>
                <div className={trackClasses} />
                <div className="toggle-thumb" />
                <input className="toggle-screenreader-only"
                    defaultChecked={checked}
                    ref={(checkbox) => this.checkboxChecked = checkbox}
                    type="checkbox"
                />
            </div>
        )
    }
}
Toggle.propTypes = {
    checked: PropTypes.bool,
    defaultChecked: PropTypes.bool,
    id: PropTypes.string,
    product: PropTypes.oneOf([OPENBANK_PRODUCT_BANKING, OPENBANK_PRODUCT_WEALTH]),
    name: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    eventCategory: PropTypes.string,
    eventTag: PropTypes.string,
    eventName: PropTypes.string
};

Toggle.defaultProps = {
    defaultChecked: false,
    product: OPENBANK_PRODUCT_BANKING
};

module.exports = Toggle;
